import { Button, Dialog, Grid, Selector, Toast, Image, AutoCenter, Badge } from 'antd-mobile';
import axios from 'axios';
import httpClient from '../../shared/api/httpClient';
import React, { useEffect, useState } from 'react'
import API_ROUTES from '../../api';
import { useNavigate } from 'react-router-dom';
import SubTeamList from './subTeamList';
import AddReferee from './addReferee';

const GameActivity = ({ gameDetail, getGameDetail, getUserListInfo, memberInfo }) => {

    const [teamInfoList, setTeamInfoList] = useState([])
    const [buttomLoading, setButtomLoading] = useState(false)

    const navigate = useNavigate()


    useEffect(() => {
        getTeamList()
    }, [])

    const getTeamList = () => {
        Toast.show({
            icon: 'loading',
        })
        axios.post(API_ROUTES.team_list, {
        })
            .then(function (response) {
                setTeamInfoList(response.data.data)
            })
            .catch(function (error) {
                console.error('获取成员列表失败', error);
            })
            .finally(() => {
                Toast.clear()
            });
    }

    const setGameTeam = (type) => {
        setButtomLoading(true)
        let chooseTeam;
        Dialog.confirm({
            title: '请选择绿队队伍',
            content: (<div>
                <Selector
                    options={teamInfoList.map(item => {
                        if (item.id === gameDetail?.greenTeam && type === 2) {
                            return {
                                label: (<AutoCenter>
                                    <Image src={item.teamLogo} width={40} />
                                </AutoCenter>),
                                description: item.teamName,
                                value: item.id,
                                disabled: true // 假设你想要禁用这个选项
                            };
                        } else if (item.id === gameDetail?.redTeam && type === 1) {
                            return {
                                label: (<AutoCenter>
                                    <Image src={item.teamLogo} width={40} />
                                </AutoCenter>),
                                description: item.teamName,
                                value: item.id,
                                disabled: true // 假设你想要禁用这个选项
                            };
                        } else {
                            return {
                                label: (<AutoCenter>
                                    <Image src={item.teamLogo} width={40} />
                                </AutoCenter>),
                                description: item.teamName,
                                value: item.id
                            }
                        }
                    })}
                    onChange={(item) => chooseTeam = item}
                />
            </div>),
            onConfirm: () => {
                Toast.show({
                    icon: 'loading',
                    duration: 0,
                })
                axios.post(API_ROUTES.game_addTeam, {
                    gameId: gameDetail?.id,
                    redTeam: type === 2 ? chooseTeam[0] : null,
                    greenTeam: type === 1 ? chooseTeam[0] : null
                }, null)
                    .then(function (response) {
                        if (response.data.code === 200) {
                            Toast.show({
                                icon: 'success',
                                content: '设置成功',
                                duration: 2,
                                afterClose: () => {
                                    getGameDetail()
                                }
                            })
                        }
                    })
                    .catch(function (error) {
                        Toast.show({
                            icon: 'fail',
                            content: "操作失败，请联系管理员！",
                        })
                    })
                    .finally(() => {
                        setButtomLoading(false)
                    });
            },
            onCancel: () => {
                setButtomLoading(false)
            }
        })
    }

    const cancleGame = () => {
        setButtomLoading(true)
        Dialog.confirm({
            title:
                <div >
                    <AutoCenter style={{ margin: '10px', fontWeight: '600', color: 'red' }}>
                        确认后当前的比赛将被取消！
                    </AutoCenter>
                </div>
            ,
            onConfirm: () => {
                axios.post(API_ROUTES.game_changeGameInfo, {
                    id: gameDetail.id,
                    status: 4
                }, null)
                    .then(function (response) {
                        if (response.data.code === 200) {
                            navigate('/home');
                        } else {
                            Toast.show({
                                icon: 'fail',
                                content: "操作失败，请联系管理员！",
                            })
                        }
                    })
                    .catch(function (error) {
                        Toast.show({
                            icon: 'fail',
                            content: "操作失败，请联系管理员！",
                        })
                    })
                    .finally(() => {
                        setButtomLoading(false)
                    });
            },
            onCancel: () => {
                setButtomLoading(false)
            }
        })
    }

    const getUserSubsitituteInfo = (team) => {
        const getList = () => {
            let teamList = team === 1
                ? gameDetail?.greenTeamMemberList?.filter(item => gameDetail.greenCaptainId !== item.memberId)
                : gameDetail?.redTeamMemberList?.filter(item => gameDetail.redCaptainId !== item.memberId)
            return teamList?.map((user) => (
                <div style={{ display: 'flex', alignItems: 'center', margin: '16px 20px' }} key={user.memberId}>
                    <Image
                        src={`${user.memberImage}?x-oss-process=image/resize,m_fill,w_100,h_100,limit_0/auto-orient,1/quality,q_90`}
                        width={40}
                        height={40}
                        fit="cover"
                        style={{
                            borderRadius: '50%',
                            border: user.gameTeam === 1 && gameDetail.greenColor
                                ? `2px solid ${gameDetail.greenColor}`
                                : user.gameTeam === 2 && gameDetail.redColor
                                    ? `2px solid ${gameDetail.redColor}`
                                    : '1px solid #CDCDCD'
                        }}
                    />
                    <span style={{
                        display: "flex",
                        justifyContent: 'center',
                        alignItems: 'center',
                        fontSize: '12px',
                        marginLeft: '10px'
                    }}>
                        {user.memberName}
                    </span>
                </div>
            ));
        };

        const getCaptain = () => {
            const captain = team === 1
                ? gameDetail?.greenTeamMemberList?.find(item => gameDetail.greenCaptainId === item.memberId)
                : gameDetail?.redTeamMemberList?.find(item => gameDetail.redCaptainId === item.memberId);
            console.log(captain)
            return captain && (

                <div style={{ display: 'flex', alignItems: 'center', margin: '16px 20px' }}>
                    <Badge color='orange' content={"C"} style={{ '--top': '100%' }}>
                        <Image
                            src={`${captain.memberImage}?x-oss-process=image/resize,m_fill,w_100,h_100,limit_0/auto-orient,1/quality,q_90`}
                            width={40}
                            height={40}
                            fit="cover"
                            style={{
                                borderRadius: '50%',
                                border: captain.gameTeam === 1 && gameDetail.greenColor
                                    ? `2px solid ${gameDetail.greenColor}`
                                    : captain.gameTeam === 2 && gameDetail.redColor
                                        ? `2px solid ${gameDetail.redColor}`
                                        : '1px solid #CDCDCD'
                            }}
                        />
                    </Badge>
                    <span style={{
                        display: "flex",
                        justifyContent: 'center',
                        alignItems: 'center',
                        fontSize: '12px',
                        marginLeft: '10px'
                    }}>
                        {captain.memberName}
                    </span>
                </div>

            );
        };

        return (
            <>
                {getCaptain()}
                {getList()}
            </>
        );
    };




    return (
        <div>
            {memberInfo?.admin === 1 &&
                <Grid columns={6} gap={8}>
                    <Grid.Item span={4}>
                        <Button color='primary' block
                            loading={buttomLoading}
                            onClick={() => {
                                if (gameDetail.redTeam && gameDetail.greenTeam) {
                                    Toast.show({
                                        icon: 'loading',
                                        content: '数据加载中...请等待',
                                        duration: 0
                                    })
                                    setButtomLoading(true)
                                    // 结束报名使用表单参数，并交给统一客户端附带长期登录凭证。
                                    httpClient.post(API_ROUTES.game_allocation, new URLSearchParams({ id: gameDetail.id }))
                                        .then(function (response) {
                                            if (response.data.code === 200) {
                                                navigate(`/games/${gameDetail.id}/ready`);
                                            } else {
                                                Toast.show({
                                                    icon: "fail",
                                                    content: response.data.msg,
                                                })
                                            }
                                        })
                                        .catch(function (error) {
                                            Toast.show({
                                                icon: 'fail',
                                                // Axios 错误内容位于 response.data，不能从 error.data 直接读取。
                                                content: error?.response?.data?.msg || error?.response?.data?.message || '结束报名失败，请稍后重试',
                                            })
                                        })
                                        .finally(() => {
                                            setButtomLoading(false)
                                        });
                                } else {
                                    Toast.show({
                                        icon: 'fail',
                                        content: '请先添加队伍!'
                                    })
                                }
                            }}
                            style={{ fontSize: '14px' }}
                        >
                            确认比赛
                        </Button>
                    </Grid.Item>
                    <Grid.Item span={2}>
                        <Button color='warning' block
                            loading={buttomLoading}
                            onClick={() => { cancleGame() }}
                            style={{ fontSize: '14px' }}
                        >
                            取消比赛
                        </Button>
                    </Grid.Item>
                    <Grid.Item span={3}>
                        <Button color='success' block
                            loading={buttomLoading}
                            onClick={() => { setGameTeam(1) }}
                            style={{ fontSize: '14px' }}
                        >
                            {gameDetail.greenTeam ? "修改" : "添加"}绿队
                        </Button>
                    </Grid.Item>
                    <Grid.Item span={3}>
                        <Button color='danger' block
                            loading={buttomLoading}
                            onClick={() => { setGameTeam(2) }}
                            style={{ fontSize: '14px' }}
                        >
                            {gameDetail.redTeam ? "修改" : "添加"}红队
                        </Button>
                    </Grid.Item>
                </Grid>
            }
            <SubTeamList gameDetail={gameDetail} />
            <Grid columns={2} gap={8}>
                <Grid.Item>
                    {getUserSubsitituteInfo(1)}
                </Grid.Item>
                <Grid.Item>
                    {getUserSubsitituteInfo(2)}
                </Grid.Item>
            </Grid>
            <AddReferee gameDetail={gameDetail} getGameDetail={getGameDetail} getUserListInfo={getUserListInfo} />
        </div>
    )
}


export default GameActivity;
